/*!

=========================================================
* BLK Design System React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/blk-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/blk-design-system-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import PageHeader from "components/PageHeader/PageHeader.js";
// import Footer from "components/Footer/Footer.js";
import WhatsAppButton from "components/WhatsAppButton";
import GradientMeshBackground from "components/GradientMeshBackground";

// sections for this page/view
import Location from "./IndexSections/Location";
import Services from "./IndexSections/Services";
import Team from "./IndexSections/Team";
// import ReviewsAPI from "./IndexSections/ReviewsAPI";
// import OrthopedicCases from "./IndexSections/OrthopedicCases";
import Offices from "./IndexSections/Offices";
import Contact from "./IndexSections/Contact";

export default function Index() {
  React.useEffect(() => {
    document.body.classList.add("index-page");

    const reveals = Array.from(document.querySelectorAll(".reveal"));

    // Sin IntersectionObserver el contenido quedaría en opacity: 0 para
    // siempre, así que en ese caso lo mostramos todo de entrada.
    if (!("IntersectionObserver" in window)) {
      reveals.forEach(el => el.classList.add("active"));
      return () => document.body.classList.remove("index-page");
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -80px 0px", threshold: 0.05 }
    );

    const observeAll = () =>
      document
        .querySelectorAll(".reveal:not(.active)")
        .forEach(el => observer.observe(el));

    observeAll();

    // Hay secciones que renderizan contenido más tarde (las reseñas esperan a
    // Google). Sin esto, un .reveal que aparece después del montaje nunca se
    // observa y queda en opacity: 0 para siempre.
    const mutations = new MutationObserver(observeAll);
    mutations.observe(document.body, { childList: true, subtree: true });

    return () => {
      document.body.classList.remove("index-page");
      observer.disconnect();
      mutations.disconnect();
    };
  }, []);
  return (
    <>
      <GradientMeshBackground />
      <IndexNavbar />
      <div className="wrapper">
        <PageHeader />
        <div className="main">
          <Services />
          <Location />
          <Team />
          {/* Reseñas ocultas hasta que la API key de Google autorice el
              dominio. El enlace del navbar está comentado en pareja. */}
          {/* <ReviewsAPI /> */}
          {/* <OrthopedicCases /> */}
          <Offices />
          <Contact />
        </div>
        {/* <Footer /> */}
      </div>
      <WhatsAppButton />
    </>
  );
}
